module.exports = __webpack_public_path__ + "img/festivalChallenge_main.0230d188.png";